import UI from "./base/UI";
import {getInputButtonClose} from "./templates/html.template";
import {showErrorMsg, showInfoMsg,showSuccessMsg} from "../functions/msg.common";

import {isA11yCheckVersion, isA11yCheckVoiceOverFocusPrevent} from "../functions/a11y.ui";
/**
 * Input
 */

/**
#### HTML 구조 및 Data 속성 사용법
** [http://172.20.160.28:9700/kbank_html_mmk/components/component_input.html](http://172.20.160.28:9700/kbank_html_mmk/components/component_input.html)
*/
class Input extends UI {
    defaults = {
        complexValue : 0,   // FETASK-1481 
        complexMaxValue: 0  // FETASK-1481 
    };

    constructor(el, options) {
        super('input', el);

        this.init(el, options);
    }

    init(el, options) {
        if (options) {
            this.defaults = {...this.defaults, ...this.parseOptions(options)};
        }
        
        this.render();
    }
    /**
    * input, select, textarea 태그에 속성값이 변경되었을경우 사용 ex) disabled, readonly
    * @example 
    * $('.ui-input').data('ui').update();
    */
    update() {
        this.$el.find('input, select, textarea').each((idx, obj) => {
            this.changeHandler($(obj));
        });

        if(this.$el.hasClass('error')) {
            this.$el.closest('.form-row').find('.form-util').addClass('error');
            this.$el.closest('.form-box-group').addClass('error');
        }
        if(this.$el.hasClass('success')) { // FETASK-1751 sussecc 케이스 추가
            this.$el.closest('.form-row').find('.form-util').addClass('success');
        this.$el.closest('.form-box-group').addClass('success');
        }

        if(this.$el.find('input, select, textarea').attr('disabled') === 'disabled') {
            this.$el.addClass('disabled');
            this.$el.find('.btn-delete-txt').off('click').addClass('hidden');

            // CHPFMTASK-2324 [KDS] done-init 비교 클래스 추가
            const formBoxGroup = this.$el.closest('.form-box-group');
            // 콤보타입 (.ui-formBox)
            if (formBoxGroup.length > 0 ) {
                formBoxGroup.hasClass('done-init') ? formBoxGroup.addClass('disabled') : formBoxGroup.addClass('disabled done');
            }

        } else {
            this.$el.removeClass('disabled');

            // 콤보타입 (.ui-formBox)
            if (this.$el.closest('.form-box-group').length > 0 ) {
                this.$el.closest('.form-box-group').removeClass('disabled');
            }
        }
        
        // CHPFMTASK-2039 done-readonly 속성 추가
        if(this.$el.attr('done-readonly') != undefined) {
            this.$el.find('input, select, textarea').attr('readonly','');
            this.$el.css('pointer-events','none');
            setTimeout(()=>{
                this.$el.attr('title',`${this.$el.attr('title')} 읽기전용`);
            },300);
        }
        
        if(this.$el.find('input, select, textarea').attr('readonly') === 'readonly') {  // 240319 : CHPFMTASK-598  readonly case 추가
            const getReadonly  = this.$el.find('input, select, textarea')[0].getAttribute('readonly');

            if (getReadonly != 'false') {
                if(getReadonly === 'true'){
                    addReadonly(this);
                    this.$el.css('pointer-events','none');
                    setTimeout(()=>{
                        this.$el.attr('title',`${this.$el.attr('title')} 읽기전용`);
                    },300);
                }else if (this.$el.find('.ui-calendar').length > 0 || this.$el.attr('data-type') == 'dateSpinner' || this.$el.hasClass('input-txt-trn')) {
                    this.$el.removeClass('readonly');
                } else {
                    addReadonly(this);
                }

                function addReadonly(target){
                    target?.$el?.addClass('readonly');
                    target?.$el?.find('.btn-delete-txt').off('click').addClass('hidden');

                    // 콤보타입 (.ui-formBox)
                    if (target.$el.closest('.form-box-group').length > 0 ) {
                        target.$el.closest('.form-box-group').addClass('readonly done');
                    }
                }
            }
        } else {
            this.$el.removeClass('readonly');

            // 콤보타입 (.ui-formBox)
            if (this.$el.closest('.form-box-group').length > 0 ) {
                this.$el.closest('.form-box-group').removeClass('readonly');
            }
        }
        if (this.$el.attr('direct-selected') != undefined) { // 직접입력
            const that = this;
            setTimeout(()=>{
                this.$el.addClass('done')
                this.$el.find('.select-txt-wrap .txt-name').text(this.$el.attr('direct-selected'))
                let optArrUnit = []
                const $directWrap = this.$el.closest('[select-type="direct"]');
                $directWrap.find('option').each(function(i,e){
                    if (i != 0) {
                        optArrUnit.push($(e).text())
                        $(e).removeAttr('selected')
                        if ($(e).text() ==  that.$el.attr('direct-selected')) {
                            $(e).attr('selected', 'selected')
                        }
                    }
                })
                if (!optArrUnit.includes(this.$el.attr('direct-selected'))) {
                    // $directWrap.find('option').each(function(i,e){
                    //     $(e).removeAttr('selected')
                    // })
                    this.$el.find('option:last').attr('selected', 'selected')
                }
            })
            
        }
        if (this.defaults.type == 'complex') { // FETASK-1481
            this.defaults.complexValue = this.$el.find('input').attr('complex-value')
            this.defaults.complexMaxValue = this.$el.find('input').attr('complex-max-value')
            this.complexSet()
            if (this.$el.next().find('[data-complex-button]').length > 0) {
                const complexButton = this.$el.next().find('[data-complex-button]');
                complexButton.find('[complex-button-text]').text(this.unitSet(this.defaults.complexMaxValue, true))
            }
            
            this.$el.next().find('[data-complex-button] button').on('click', (e)=>{
                this.$el.find('input').val(this.commaSet(this.defaults.complexMaxValue.slice(0,-4)));
                this.$el.find('input').attr('complex-value', this.defaults.complexMaxValue)
                
                if(this.$el.next().hasClass('reset')){
                    this.$el.removeClass('reset')
                    this.$el.next().removeClass('reset')
                }
                this.complexSet('click')
            })
        }
    }

    // FETASK-1481
    // data-complex-text 속성값 있을때 사용 
    complexSet(eventType){
        
        const complexValue = this.$el.find('input').attr('complex-value')
        const complexMaxValue = this.$el.find('input').attr('complex-max-value')
        if (this.$el.next().find('[data-complex-text]').length > 0 && this.$el.next().find('[data-complex-text]').attr('data-complex-text') == 'text') {
            this.$el.find('input').val(this.commaSet(complexValue.replace(/,/g,'').slice(0,-4))).attr('value', complexValue.replace(/,/g,'').slice(0,-4))
        } else {
            this.$el.find('input').val(this.commaSet(complexValue.replace(/,/g,''))).attr('value', complexValue.replace(/,/g,''))  // 풀자리로 들어갈때 필요함
        }
        let complexText, complexTextArea
        if (this.$el.next().find('[data-complex-text]').length > 0) {
            complexText = this.$el.next().find('[data-complex-text]');
            complexTextArea= this.$el.next().find('[complex-txt]');
            if (complexText.attr('data-complex-text') == 'text') {
                complexTextArea.text(this.unitSet(complexValue.replace(/,/g,''), true))
            } else if (complexText.attr('data-complex-text') == 'comma'){
                // (`${this.commaSet($this.val()) + _unit}`) // 추후 원,명 필요할시 unit 은 옵션값으로 받아와야 한다
                complexTextArea.text(`${this.commaSet(complexValue.replace(/,/g,''))}${complexTextArea.attr('complex-txt-unit')}`)
            } else {
                complexTextArea.text(complexValue.replace(/,/g,''))
            }
        }
        if (eventType == 'focusout' || eventType == 'click') {
            this.$el.removeClass('reset')
                if(this.$el.next().find('[data-complex-text]').length>0){
                    this.$el.next().removeClass('reset')
                }
        } else {
            if (this.defaults.complexValue == '' ||  this.defaults.complexValue == 0) {
                this.$el.addClass('reset')
                if(this.$el.next().find('[data-complex-text]').length>0){
                    this.$el.next().addClass('reset')
                }
            }
        }
        
    }

    render() {
        if (this.defaults.type == 'direct-select') { // 230808 |  셀렉트 직접입력 관련 추가
            
            const $directInp = this.$el.closest('[select-type="direct"]').find('[direct-input]');
            this.$el.attr('direct-unit') == undefined ? '' : $directInp.addClass('txt-right');
            this.$el.attr('direct-input-type') == undefined ? $directInp.find('input').attr('type','text') : $directInp.find('input').attr('type', this.$el.attr('direct-input-type'));
            $directInp.find('input').attr('id', `directInp${$('[direct-input]').length}`)
            $directInp.find('label').attr('for', `directInp${$('[direct-input]').length}`)
            $directInp.find('label').text(this.$el.find('.selectbox-label-field').text())
            this.$el.attr('direct-unit') == undefined ? $directInp.find('.txt-field').css('display','none') : 
            $directInp.find('.txt-field').css('display','block').text(this.$el.attr('direct-unit'))
        }
        
        if (this.$el.closest('.form-row').find('.form-util .sum').length > 0) {
            this.textCount = true;
        }
        if (typeof this.$el.attr('data-hidden-cursor') !== 'undefined' && this.$el.find('.fake_cursor').length <= 0){
            this.fakeCursorInit();
        }
        if(this.$el.find('input').length || this.$el.find('textarea').length){
            this.defaults.winHeight = window.innerHeight;
            this.defaults.yOffset = parseInt(this.$el[0].getBoundingClientRect().bottom);
        }
        if(this.defaults.textMapping){
            this.$el.find('textarea').attr('maxlength', this.defaults.maxLength);
        }
        if(this.$el.find('textarea').length && this.$el.find('textarea').attr('line-break') || this.$el.find('textarea').attr('line-break') == ''){
            this.$el.append(`
            <div class='dummy-area' style='
            left:0; 
            top:0; 
            height:100%; 
            opacity:0;
            display: inline-block;
            position:absolute; 
            pointer-events:none; 
            font-size: 2.8rem;
            line-height: 3.6rem;
            font-weight: 700;
            z-index:-1;' 
            tabindex='-1' 
            aria-hidden='true'>
            </div>`);
        }
        this.detachEvents();
        this.attachEvents();
        this.valueChkHiddenBtn();

        /*! s: FETASK-a11y page input 셀렉트 Type v.1.0.0 */
        this.isA11yFormBox();
        /*! e: FETASK-a11y page input 셀렉트 Type v.1.0.0 */
    }

    changeHandler($this, eventType = null){
        const valueOn = this.$el.find('input, textarea, select').toArray().some(this.isNotEmpty);
        if (valueOn) {
            // this.$el.addClass('done active');
            this.$el.addClass('done');

            // CHPFMTASK-1224 번호입력시 active 클래스 유지
            if(this.$el.find('>input').attr('type') == 'tel' && this.$el.find('>input').attr('id') == 'changedPhoneNumber'){
                this.$el.addClass('active');
            }

            if (this.$el.hasClass('type-chk')) {
                if (this.$el.find('input[type=text]').val().length <= 0) {
                    if (document.activeElement.type !== 'text') {
                        this.$el.addClass('type-chk-empty');
                    }
                } else {
                    this.$el.removeClass('type-chk-empty');
                }
            }
            if (this.defaults.flexibleSize) {
                if ($this.closest('.container-component').find('.flexibleInpText').length <= 0) {
                    $this.closest('.container-component').append('<span class="flexibleInpText" style="color:transparent; opacity:0; visibility: hidden; position:absolute;" aria-hidden="true"></span>')
                }
                $('.flexibleInpText').text($this.val());
                const nowSize = $('.flexibleInpText').css('width');
                $this.css({'width': nowSize});
            }
            if (this.defaults.type == "complex" && eventType != null && eventType == 'input') { // FETASK-1481
                if (this.$el.next().find('[data-complex-text]').length > 0 && this.$el.next().find('[data-complex-text]').attr('data-complex-text') == 'text') {
                    this.$el.find('input').attr('complex-value', this.$el.find('input').val().replace(/,/,'')+'0000' )
                } else {
                    this.$el.find('input').attr('complex-value', this.$el.find('input').val().replace(/,/,'') )  // 풀자리로 들어갈때 필요함
                }
                this.complexSet(eventType)
            }
        } else {
            if (eventType !== 'input') {
                this.$el.removeClass('done');
            }
            if ($this) {
                $this.css({'width': ''});
                if ($this.closest('.container-component').find('.flexibleInpText').length > 0) {
                    $this.closest('.container-component').find('.flexibleInpText').remove();
                }
            }
            if (this.$el.hasClass('type-chk')) {
                this.$el.removeClass('type-chk-empty');
            }
            if (this.defaults.type == "complex" && eventType == 'input') { // FETASK-1481
                if($this.val() == ''){
                    this.$el.addClass('reset')
                    this.$el.find('input').attr('complex-value', 0)
                    if(this.$el.next().find('[data-complex-text]').length>0){
                        this.$el.next().addClass('reset')
                    }
                }
                
            }
        }

        if($this?.attr('line-break') != undefined && $this?.attr('line-break') != null){
           const parentEl = $this.closest('.input-txt-group'),
            dummyArea = $('.dummy-area');
            if(dummyArea.length > 0) {
                dummyArea.text($this.val());
                (dummyArea.width() > $this.width()) ?  (parentEl.attr('style','height:auto !important;'), $this.removeAttr('rows')) : (parentEl.removeAttr('style'), $this.attr('rows',1));
            }
        }

        if ($this && $this.hasClass('ui-text-del')) {
            if ($this.val().length > 0) {
                if ($this.next('.btn-delete-txt').length <= 0) {
                    $this.after(getInputButtonClose());
                    if (document.activeElement !== $this[0]) {
                        if(!isA11yCheckVersion()) $this.next('.btn-delete-txt').addClass('hidden');
                    }
                }else{
                    $this.next( ".btn-delete-txt").removeClass( "hidden" );
                }

                const _that = this;
                $this.next('.btn-delete-txt').off('click').on('click', (e) => {
                    e.stopPropagation();

                    if (_that.deleteCallback) {
                        _that.deleteCallback.forEach((fn) => {
                            if ($.isFunction(fn)) {
                                fn();
                            }
                        })
                    }
                    if(isA11yCheckVersion()){
                        $this.next('.btn-delete-txt').off('click');
                    }else{
                        $this.next('.btn-delete-txt').off('click').addClass('hidden');
                    }
                    
                    $this[0].value = '';
                    _that.$el.removeClass('error success'); // FETASK-1751 sussecc 케이스 추가
                    _that.$el.closest('.form-row').find('.form-util').removeClass('error success'); // FETASK-1751 sussecc 케이스 추가
                    _that.$el.closest('.form-box-group').removeClass('error success'); // FETASK-1751 sussecc 케이스 추가

                    if (_that.textCount === true) {
                        _that.textLengthCount();
                    }

                    if (_that.$el.attr('printName') == ""){
                        _that.$el.find('input').trigger('keyup')
                    }

                    $this.focus();

                    if (typeof _that.$el.attr('data-hidden-cursor') !== 'undefined'){
                        if (_that.$el.find('.fake_cursor').length <= 0) {
                            _that.fakeCursorInit();
                        }
                        _that.$el.addClass('active');
                        _that.$el.find('.fake_cursor')[0].style.animationPlayState = 'paused'
                        setTimeout(() => {
                            _that.$el.find('.fake_cursor')[0].style.animationPlayState = 'running'
                        }, 150);
                        _that.$el.find('.fake_cursor').show();
                        _that.fakeCursorActive($this);
                    }

                    if (_that.defaults.type == "complex" && _that.$el.next('.form-util').length > 0) { // FETASK-1481 
                        _that.$el.addClass('reset')
                        _that.$el.next('.form-util').addClass('reset')
                    }

                    // console.log(_that.$el.next('.form-util').find('.helper-msg > em').eq(0));

                    // 14일 정기 배포에 올릴 스크립트 클릭시 입력 초기화 마크업 비교
                    const sumEl = _that.$el.next('.form-util').find('.helper-msg > .sum'), 
                    emEl = _that.$el.next('.form-util').find('.helper-msg > em').eq(0);
                    let msgResetTarget = (sumEl.length > 0) ? msgResetTarget = sumEl : msgResetTarget = emEl;
                    if(msgResetTarget.length > 0) msgResetTarget.text(0);
                    

                    // 240708 클릭시 입력값 표기 초기화 추가
                    // const msgEl = _that.$el.next('.form-util').find('.helper-msg > em');
                    // if(msgEl.length > 0){
                    //     msgEl.text(0);
                    // }

                    $this.next( ".btn-delete-txt" ).addClass( "hidden" );
                });
                
                if (this.$el.hasClass('active')) {
                    if(!isA11yCheckVersion()) $this.next('.btn-delete-txt').removeClass('hidden');
                }
                
            } else {
                $this.next( ".btn-delete-txt" ).addClass( "hidden" );
                // $this.next('.btn-delete-txt')[0] && $this.next('.btn-delete-txt').remove();

                if ($this[0].offsetParent === null) {
                    // this.$el.find('input, textarea, select').blur();
                    if(!this.$el.hasClass('ui-placeholder') && !this.$el.hasClass('ui-placeholder-def')) {
                        this.$el.find('input, textarea, select').attr('placeholder', this.placeholderOn);
                    }
                }
                if ($this.val() != '') {
                    //$this.next('.btn-delete-txt').removeClass('hidden')
                    if (!this.$el.find('.checkbox-txt-field').length > 0) { // CHPFMTASK-1279
                        if(!isA11yCheckVersion()) $this.next('.btn-delete-txt').removeClass('hidden')
                    }
                }
            }
        }
        
        if (this.textCount === true) {
            this.textLengthCount();
        }

        if (typeof this.$el.attr('data-hidden-cursor') !== 'undefined'){
            if (this.$el.find('.fake_cursor').length <= 0) {
                this.fakeCursorInit();
            }
            this.fakeCursorActive($this);
        }
    }

    fakeCursorInit(){
        this.$el.append('<span class="fake_cursor" aria-hidden="true"></span>');
        const inputStyle = window.getComputedStyle(this.$el.find('input')[0])
        let lineHeightNum;

        if (inputStyle.lineHeight === 'normal') {
            lineHeightNum = parseInt(inputStyle.fontSize) * 1.14;
        } else {
            lineHeightNum = Math.floor(parseInt(inputStyle.lineHeight));
        }

        this.$el.find('.fake_cursor').css({
          'font-size': `${inputStyle.fontSize}`,
          'font-variant-numeric': `${inputStyle.fontVariantNumeric}`,
          'padding-left': `${inputStyle.paddingLeft}`,
          'line-height': `${inputStyle.lineHeight}`,
          'height': `${lineHeightNum}px`,
        });
    }

    fakeCursorActive($this){
        const wrap = $this.closest('[data-hidden-cursor]');
        const nowVal = $this.val();
        const maxW = $this.width();
        if (!wrap.find('.fake_cursor').is(':visible')) {
            this.$el.find('.fake_cursor')[0].style.animationPlayState = 'paused';
            setTimeout(() => {
                this.$el.find('.fake_cursor')[0].style.animationPlayState = 'running'
            }, 150);
            wrap.find('.fake_cursor').show();
        }
        wrap.find('.fake_cursor').css({
            'max-width': `${maxW + parseInt($this.css('padding-left'))}px`
        })
        wrap.find('.fake_cursor').text(nowVal);
    }

    textLengthCount() {
        if(this.defaults.limitedRow) return false;
        const targetInput = this.$el.find('textarea, input').val();
        // const nowLength = (targetInput === undefined || targetInput === '') ? 0 : this.getByteLength(targetInput);
        const nowLength = (targetInput === undefined || targetInput === '') ? 0 : targetInput.length;

        this.$el.closest('.form-row').find('.form-util .sum').text(nowLength);
    }

    getByteLength(str){
        let byteLength = 0;
        for (let i = 0; i < str.length; i++) {
            const oneChar = escape(str.charAt(i));
            if (oneChar.length == 1) {
                byteLength ++;
            } else if (oneChar.indexOf("%u") != -1) {
                byteLength += 2;
            } else if (oneChar.indexOf("%") != -1) {
                byteLength += oneChar.length/3;
            }
        }
        return byteLength;
    }

    valueChkHiddenBtn () {

        // if (this.$el.find('input').length > 0 && this.$el.find('input').val() != '' ) {  //CHPFMTASK-1279
        //     console.log(111)
        //     this.$el.find('input').next('.btn-delete-txt').removeClass('hidden')
        // } else {
        //     console.log(2222)
        //     this.$el.find('input').next('.btn-delete-txt').addClass('hidden')
        // }
        // 2023-06-09 FETASK-1050   |  this.$el.hasClass('focus') 추가 
        if (this.$el.find('input').length > 0 && this.$el.find('input').val() != '' && this.$el.hasClass('focus') ) {
            if(!isA11yCheckVersion()) this.$el.find('input').next('.btn-delete-txt').removeClass('hidden')
        }
        
    }

    attachEvents() {
        const that = this;
        let fixedCTATimer = -1;
        let observerTimer = null;

        this.placeholderOn =this.$el.find('input, textarea, select').attr('placeholder');

        const inputList = [
            'input[type=email]',
            'input[type=text]',
            'input[type=number]',
            'input[type=password]',
            'input[type=search]',
            'input[type=tel]',
            'input[type=url]',
            'textarea'
        ];

        if(this.$el.hasClass('error')) {
            this.$el.closest('.form-row').find('.form-util').addClass('error');
            this.$el.closest('.form-box-group').addClass('error');
        }
        if(this.$el.hasClass('success')) { // FETASK-1751 sussecc 케이스 추가
            this.$el.closest('.form-row').find('.form-util').addClass('success');
            this.$el.closest('.form-box-group').addClass('success');
        }
        
        // const scrollTarget = this.$el.closest('.page-inner-scroll').length ? this.$el.closest('.page-inner-scroll') : $(window);
        // scrollTarget.on('touchstart', (e) => {
        //     if(this.$el.find('input').length){
        //         this.defaults.observer && this.defaults.observer.unobserve(this.$el.find('input')[0]);
        //     }
        //     if(this.$el.find('textarea').length){
        //         this.defaults.observer && this.defaults.observer.unobserve(this.$el.find('textarea')[0]);
        //     }
        // });

        if(this.defaults.textMapping){
            const carvedArea = document.querySelector(`.${this.defaults.textMapping}`);
            const textArea = this.$el.find('textarea')[0];
            textArea.data = [];
            textArea.line = 0;

            textArea.addEventListener('keyup', (e) => {
                const key = e.keyCode;
                const strValue = e.target.value

                if(textArea.data[this.defaults.maxRows-1]){
                    if(textArea.data[this.defaults.maxRows-1].length >= 6){
                        return false;
                    }
                }
                
                if(strValue.length > 18){
                    e.target.value = strValue.slice(0, 18);
                    carvedArea.dataset.text = e.target.value;
                    carvedMappingText(carvedArea.dataset.text);
                    return false;
                } 
                
                carvedArea.dataset.text = strValue;

                //엔터 체크
                if(key === 13){
                    carvedArea.dataset.text = carvedArea.dataset.text.replace(/(?:\r\n|\r|\n)/g, "\r\n");                
                }
                
                carvedMappingText(carvedArea.dataset.text);
            });

            function carvedMappingText(value){
                value = value.replace(/(.{6})/g, "$1\n");   // 여섯글자마다 개행문자(\n) 삽입
                value = value.replace(/(?:\r\n|\r|\n)/g, "<br>");   // 개행문자를 <br>태그로 치환
                                
                carvedArea.innerHTML = value;
                textArea.data = carvedArea.innerText.split('\n');
                textArea.line = textArea.data.length > that.defaults.maxRows ? that.defaults.maxRows : textArea.data.length;
            }
        }

        this.$el.on(`input${this.eventId} change${this.eventId} propertychange${this.eventId} paste${this.eventId} customChange${this.eventId}`,
            [
                ...inputList,
                'input[type=checkbox]',
                'input[type=radio]',
                'select',
                '.btn-delete-txt'
            ].join(','),
            (e) => {
                const $this = $(e.currentTarget);
                // console.log($this[0], 'input!!!!');
                this.changeHandler($this, e.type);
                if ($this.val() != '' && e.type == 'input') {
                    if(!isA11yCheckVersion()) $this.next('.btn-delete-txt').removeClass('hidden');
                    if (this.defaults.type == 'complex' && this.$el.next('.form-util').length > 0 && this.$el.next('.form-util').hasClass('reset')) { // FETASK-1481 
                        this.$el.removeClass('reset')
                        this.$el.next('.form-util').removeClass('reset')
                    }
                } else if ($this.val() == '') { // FETASK-985 : 230821 : input delete 버튼 지우기
                    if(!isA11yCheckVersion()) $this.next('.btn-delete-txt').addClass('hidden');
                }
                if (typeof this.$el.attr('data-hidden-cursor') !== 'undefined'){
                    if ($this.val() != '') {
                        if(!isA11yCheckVersion()) $this.next('.btn-delete-txt').removeClass('hidden');
                    } else {
                        if(!isA11yCheckVersion()) $this.next('.btn-delete-txt').addClass('hidden');
                    }
                }
                if (this.defaults.type == 'direct-select') { // 230808 |  셀렉트 직접입력 관련 추가
                    this.$el.removeAttr('direct-selected');
                    // ui-placeholder or ui-placeholder-def 두가지 클래스 중에 하나가 있어야 초기화 안됨
                    // const directInput = this.$el.next('[direct-input]'), directText = '직접입력';
                    // if(directInput.length > 0){
                    //     directInput.addClass('ui-placeholder').find('input')?.attr('placeholder', directText).attr('title', directText);
                    // }
                }

                // 접근성 관련 인풋 포커스 빠질때 다시 포커스 시키는 로직 테스트용
                // $this.closest('.ui-input').find('*:not(input)').off(`focusin`).on(`focusin`, (e) => {
                //     console.log('QQQQQQ = ',$this)
                //     $this.focus();
                // });

        }).on(`focusin${this.eventId}`, inputList.join(','), (e) => {
            const $this = $(e.currentTarget);
            // console.log( $this[0], 'focusin!!!!');
            const valueOn = this.$el.find('input, textarea, select').toArray().some(this.isNotEmpty);
            frontUI.refreshUI()
            if ($this.val() != '') {
                if(!isA11yCheckVersion()) $this.next('.btn-delete-txt').removeClass('hidden')
            }
            if(valueOn) {
                this.changeHandler($this);
            }

            window.globalFixedCTATimer && window.globalFixedCTATimer.forEach((_timerId, index) => {
                clearTimeout(_timerId);
                window.globalFixedCTATimer.splice(index, 1);
            });
            if (!this.$el.find('.ui-calendar').length>0) {
                this.$el.addClass('done').addClass('active');
            } else {
                //this.$el.addClass('focus'); // 231030 : 캘린더 팝업 열리때 active (label 작게 올라가는 class) 추후 focus라는 클래스로 검은테두리 생성해야할듯 미리 넣어봄
            }
            
            if(!this.$el.hasClass('ui-placeholder') && !this.$el.hasClass('ui-placeholder-def')){
                this.$el.find('input, textarea, select').attr('placeholder' , '');
            }

            // 콤보타입 (.ui-formBox)
            if ($this.closest('.ui-formBox').length > 0) {
                $this.closest('.ui-formBox').data('ui').focusIn();
            }
            if (typeof this.$el.attr('data-hidden-cursor') !== 'undefined'){
                this.$el.find('.fake_cursor').show();
            }

            if (this.$el.attr('printName') == ""){ //FPMPPY0200000100S.html  페이지 사용
                if ($('[data-zoom="card"]').length > 0) {
                    $('[data-zoom="card"]').addClass('focus-card-zoom');
                }  
                setTimeout(()=>{
                    if (this.$el.closest('.page-inner-scroll').find('.ui-swiper').attr('offsetTop')  === undefined) {
                        this.$el.closest('.page-inner-scroll').find('.ui-swiper').attr('offsetTop' ,this.$el.closest('.page-inner-scroll').find('.ui-swiper').offset().top)
                    }
                    if ($('html').hasClass('ios')) {
                        $(window).scrollTop(this.$el.closest('.page-inner-scroll').find('.ui-swiper').attr('offsetTop') - 17);
                    } else {
                        this.$el.closest('.page-inner-scroll').scrollTop(this.$el.closest('.page-inner-scroll').find('.ui-swiper').attr('offsetTop') - 7);
                    }
                 },50);
            }

            if (this.$el.hasClass('type-chk') && document.activeElement.type === 'text') {
                this.$el.removeClass('type-chk-empty');
            }

        }).on(`focusout${this.eventId}`, inputList.join(','), (e) => {
            const $this = $(e.currentTarget);
            // console.log( $this[0], 'focusout!!!!!');
            setTimeout(()=>{
                if ($this.closest('[direct-input]').length > 0 ) { // 230808 |  셀렉트 직접입력 관련 추가, 230728 | 수정
                    const $directWrap = $this.closest('[select-type="direct"]');
                    $directWrap.find('.input-txt-group').addClass('active');
                        if ($directWrap.find('.input-txt-group').hasClass('active') || $directWrap.find('.input-txt-group').hasClass('error') || $directWrap.find('.input-txt-group').hasClass('success')){ // FETASK-1751 sussecc 케이스 추가
                            setTimeout(() => {
                                $directWrap.removeClass('active')
                            }, 60);
                            if ($this.val() != '') {
                                console.log('첫번째로직 탐', $this.val())
                                const numChk = /[0-9]/;
                                $directWrap.find('.selectbox-group').addClass('done')
                                if (numChk.test($this.val())) {
                                    const _unit = $directWrap.find('.selectbox-group').attr('direct-unit') == undefined ? '' : $directWrap.find('.selectbox-group').attr('direct-unit');
                                    let optArrUnit = []
                                    let optArrNoUnit = []
                                    // for (var i = 0; i < $directWrap.find('option').length; i++) {
                                    //     
                                    // }
                                    $directWrap.find('option').each(function(i,e){
                                        if (i != 0 && i != $directWrap.find('option').length-1) {
                                            optArrUnit.push($(e).text())
                                            optArrNoUnit.push($(e).text().replace('만원','0000'))
                                        }
                                    })
                                    if (optArrNoUnit.includes($this.val())) {
                                        $directWrap.find('.ui-select-btn .txt-name').text(optArrUnit[optArrNoUnit.indexOf($this.val())])
                                        $directWrap.find('option').each(function(i,e){
                                            $(e).removeAttr('selected')
                                            if (i == optArrNoUnit.indexOf($this.val()) + 1){
                                                $(e).attr('selected', 'selected')
                                                that.update();
                                            }
                                        })
                                    } else {
                                        $directWrap.find('.ui-select-btn .txt-name').text(`${this.commaSet($this.val()) + _unit}`)
                                        $directWrap.find('option').each(function(i,e){
                                            $(e).removeAttr('selected')
                                        })
                                        $directWrap.find('option:last').attr('selected', 'selected')
                                    }
                                } else {
                                    $directWrap.find('.ui-select-btn .txt-name').text(`${$this.val()}`)
                                }
                            } else {
                                $directWrap.find('option').each(function(i,e){
                                    $(e).removeAttr('selected')
                                })
                                that.update();
                                $directWrap.find('.selectbox-group').removeClass('done')
                            }
                        }
                }
            })
            if ($this.closest('[data-longtab]').length > 0) { // FETASK-972
                if ($this.closest('[data-longtab]').find('.paste-tooltip').length > 0 ) {
                    $this.closest('[data-longtab]').find('.paste-tooltip').stop().animate({
                        opacity:0
                    }, ()=>{
                        $this.closest('[data-longtab]').find('.paste-tooltip').remove();
                    })
                }
            }
            const valueOn = this.$el.find('input, textarea, select').toArray().some(this.isNotEmpty);
            if (!valueOn) {
                this.$el.removeClass('done');

                setTimeout(() => {
                    if(!this.$el.hasClass('ui-placeholder') && !this.$el.hasClass('ui-placeholder-def')) {
                        this.$el.find('input, textarea, select').attr('placeholder', this.placeholderOn);
                    }
                }, 300);
            } else {
                if (this.$el.hasClass('type-chk')) {
                    if (this.$el.find('input[type=text]').val().length <= 0) {
                        this.$el.addClass('type-chk-empty');
                    }
                }
            }

            if(this.$el.hasClass('error')) {
                this.$el.closest('.form-row').find('.form-util').addClass('error');
                this.$el.closest('.form-box-group').addClass('error');
            }
            if(this.$el.hasClass('success')) { // FETASK-1751 sussecc 케이스 추가
                this.$el.closest('.form-row').find('.form-util').addClass('success');
                this.$el.closest('.form-box-group').addClass('success');
            }

            // 콤보타입 (.ui-formBox)
            if ($this.closest('.ui-formBox').length > 0) {
                $this.closest('.ui-formBox').data('ui').focusOut();
            }

            //CTA 관련된 소스 같음..확인 후 삭제 예정
            fixedCTATimer = setTimeout(() => {
            }, 10);

            if(!window.globalFixedCTATimer){
                window.globalFixedCTATimer = [];
            }

            window.globalFixedCTATimer.push(fixedCTATimer);

            
            if (typeof this.$el.attr('data-hidden-cursor') !== 'undefined'){
                this.$el.find('.fake_cursor').hide();
                if ($this.val() == '') {
                    this.$el.removeClass('active');
                }
            } else {
                if (!isA11yCheckVersion() && this.$el.find('.btn-delete-txt').length > 0) { // 240529 삭제 버튼  포커스 관련 추가 
                    if (this.$el.find('.btn-delete-txt').hasClass('hidden')) {
                        this.$el.removeClass('active');
                        console.log('???')
                    }
                }
                // this.$el.removeClass('active');t
                setTimeout(() => {
                    if (!this.$el.find('.ico-search-input').length > 0 ) { // CHPFMTASK-925  //CHPFMTASK-1279
                        if ($(e.relatedTarget).closest('.ui-input')[0] != this.$el[0]) { //CHPFMTASK-1279
                            
                            if(isA11yCheckVersion()){
                                // 250422 주석처리 A11YTASK-489
                                // $this.next('.btn-delete-txt').off('click');
                            }else{
                                $this.next('.btn-delete-txt').off('click').addClass('hidden');
                            }
                            
                            this.$el.removeClass('active');
                        }
                        
                    }
                    
                }, 150);
            }
            if (this.$el.attr('printName') == ""){ //FPMPPY0200000100S.html  페이지 사용
                if ($('[data-zoom="card"]').length > 0) {
                    $('[data-zoom="card"]').removeClass('focus-card-zoom');
                }
            }
            // this.$el.find('.ui-select-btn .txt-name').text(this.$el.find('.ui-text-del').val())
            // this.$el.removeClass('show')

            if (this.defaults.type == "complex" && !this.$el.hasClass('reset')) { // FETASK-1481
                this.complexSet('focusout')
            }
            if (!this.$el.find('.btn-delete-txt').length > 0) { // CHPFMTASK-1279
                if (!this.$el.find('.checkbox-txt-field').length > 0) {
                    this.$el.removeClass('active');
                }
                    
            }
            //this.$el.removeClass('active');
        });

        this.$el.on('focusout', (e)=>{  // // 240529 삭제 버튼  포커스 관련 
            if (!e.target.classList.contains('ui-text-del') ) {
                // if (!this.$el.find('.btn-delete-txt').length > 0) { // CHPFMTASK-1279
                //     this.$el.removeClass('active');
                // }
                setTimeout(() => {
                    if (!this.$el.find('.ico-search-input').length > 0 ) { // CHPFMTASK-925
                        if (!($(e.relatedTarget).closest('.ui-input').length > 0 &&  $(e.relatedTarget).closest('.ui-input')[0] == this.$el[0])) { // CHPFMTASK-1279
                            this.$el.removeClass('active');

                            if(isA11yCheckVersion()){
                                this.$el.find('.btn-delete-txt').off('click');
                            }else{
                                this.$el.find('.btn-delete-txt').off('click').addClass('hidden');
                            }
                        }
                        
                    }
                }, 150);
            }
        })

        // 키패드 테스트
        const virtualKeypad = document.querySelector('.virtual-keypad');

        if(virtualKeypad){
            this.$el.on(`focusin${this.eventId}`, inputList.join(','), (e) => {
                virtualKeypad && virtualKeypad.classList.add('active');

                if( virtualKeypad.classList.contains('active')){
                    this.defaults.viewportHeight = this.defaults.winHeight - virtualKeypad.getBoundingClientRect().height;
                }

                if(document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA'){
                    const target = document.activeElement;

                    if(target !== this.$el.find('input')[0] && target !== this.$el.find('textarea')[0]) return false;

                    setTimeout(() => {
                        if(this.defaults.winHeight > this.defaults.viewportHeight){ // 키패드 유무체크(viewport resize)
                            const txtPreview = document.querySelector('.card-nickname-group .text-preview');
                            if(txtPreview){
                                this.autoScrollByFocus(txtPreview);
                            }else{
                                $('html').hasClass('android') && this.autoScrollByFocus(target);
                            }
                        }
                    }, 500);
                }   

            }).on(`focusout${this.eventId}`, inputList.join(','), (e) => {
                virtualKeypad && virtualKeypad.classList.remove('active');
            });
        }

        // 키패드 노출로 resize 이벤트 발생시
        window.visualViewport && window.visualViewport.addEventListener('resize', () => {   
            
            // [FETASK-1177] input focus시 스크롤 포지션 조정
            if(document.activeElement.tagName === 'INPUT' || document.activeElement.tagName === 'TEXTAREA'){
                const target = document.activeElement;

                if(target !== this.$el.find('input')[0] && target !== this.$el.find('textarea')[0]) return false;
                    
                if(this.defaults.winHeight > parseInt(window.visualViewport.height)){ // 키패드 유무체크(viewport resize)
                    const txtPreview = document.querySelector('.card-nickname-group .text-preview');
                    if(txtPreview){
                        this.autoScrollByFocus(txtPreview);
                    }else{
                        $('html').hasClass('android') && this.autoScrollByFocus(target);
                    }
                }
            }   
        });

        this.update();
    }
    /**
    * 벨리데이션 체크 성공 케이스 
    * @param mgs    {String}  메세지값
    * @example 
    *  $('.ui-input').data('ui').success(msg);
    */
    success(msg){ // FETASK-1751 sussecc 케이스 추가
        if(this.$el.closest('.ui-formBox')[0]){
            return;
        }
        showSuccessMsg.call(this, msg);
    }
    /**
    * 벨리데이션 체크 성공 케이스 
    * @param  {String}  mgs 메세지값
    * @example 
    *  $('.ui-input').data('ui').error(msg);
    */
    error(msg){
        if(this.$el.closest('.ui-formBox')[0]){
            return;
        }
        showErrorMsg.call(this, msg);
    }
    /**
    * 벨리데이션 체크 인포 케이스 
    * @param {String} mgs 메세지값
    * @example 
    *  $('.ui-input').data('ui').info(msg);
    */
    info(msg){
        if(this.$el.closest('.ui-formBox')[0]){
            return;
        }
        const infoTextLeft = this.$el.attr('info-text-left') == undefined ? true : false;  // 240109 : 인포메세지 왼쪽으로 나오는 경우 추가
        showInfoMsg.call(this, msg ,infoTextLeft);
    }

    // isNotEmpty(obj) {
    //     if (obj.tagName.toLowerCase() === 'input') {
    //         if (obj.type === 'radio' || obj.type === 'checkbox') {
    //             const name = $(obj).attr('name');
    //             const checked = $(obj).closest('.ui-input').find(`[name=${name}]:checked`);

    //             if (checked.length > 0) {
    //                 return true;
    //             }
    //         } else {
    //             if ($(obj).val().trim() !== '') {
    //                 return true;
    //             }
    //         }
    //     } else if (obj.tagName.toLowerCase() === 'select') {
    //         if ($(obj).val().trim() !== '') {
    //             return true;
    //         }
    //     } else if (obj.tagName.toLowerCase() === 'textarea') {
    //         if ($(obj).val().trim() !== '') {
    //             return true;
    //         }
    //     }

    //     return false;
    // }

    isNotEmpty(obj) {
        if (obj.tagName.toLowerCase() === 'input') {
            if (obj.type === 'radio' || obj.type === 'checkbox') {
                const name = $(obj).attr('name');
                const checked = $(obj).closest('.ui-input').find(`[name=${name}]:checked`);
                if (checked.length > 0) {
                    return true;
                }
            } else {
                var value = $(obj).val();
                if (value !== null && value !== undefined && value.trim() !== '') {
                    return true;
                }
            }
        } else if (obj.tagName.toLowerCase() === 'select') {
            var value = $(obj).val();
            if (value !== null && value !== undefined && value.trim() !== '') {
                return true;
            }
        } else if (obj.tagName.toLowerCase() === 'textarea') {
            var value = $(obj).val();
            if (value !== null && value !== undefined && value.trim() !== '') {
                return true;
            }
        }
    
        return false;
    }
    /**
     * input.ui-text-del 값 입력시 생성되는 .btn-delete-txt 버튼 클릭시 실행할 콜백함수 추가
     * @param callback    {function}  input 값 삭제시 실행된 함수
     * @example 
     * $('.ui-input').data('ui').beforeDeleteCallback(function(){});
     */
    beforeDeleteCallback(callback) {
        if (this.deleteCallback) {
            const nowCallLength =  this.deleteCallback.length
            this.deleteCallback[nowCallLength] = callback;
        } else {
            this.deleteCallback = []
            this.deleteCallback[0] = callback;
        }
    }

    // [FETASK-1177] 가시성을 판별하여 엘리먼트(input)의 스크롤 포지션 조정
    autoScrollByFocus(el){
        const target = el;
        const ypos = parseInt(target.getBoundingClientRect().bottom);
        const fixedElem = target.closest('.activeSlide') ? target.closest('.activeSlide').querySelector('.fixed-bottom') : document.querySelector('.fixed-bottom');
        const viewportHeight = fixedElem ? parseInt(window.visualViewport.height) - fixedElem.clientHeight : parseInt(window.visualViewport.height);
        // const viewportHeight = fixedElem ? this.defaults.viewportHeight - fixedElem.clientHeight : this.defaults.viewportHeight;


        if(ypos > viewportHeight){
            if(target.classList.contains('text-preview')){
                const resizeHeight = $('html').hasClass('android') ? viewportHeight : parseInt(window.visualViewport.height);
                
                
                if(resizeHeight >= ypos) return false;
                
                const ypos2 = Math.abs(resizeHeight - ypos);
                setTimeout(() => {
                    target.closest('.activeSlide').querySelector('.page-inner-scroll').scrollTop += ypos2;
                }, 0);
            }else{
                target.scrollIntoView({'block':'center'});
            }                 
        }
    }

    async autoScrollByObserver(el){
        let target = el;
        let fixedElem = $('button.primary1').closest('.fixed-bottom');
        let options = {
            root: target.closest('.ui-popup') ? target.closest('.popup-content') : null,
            rootMargin: fixedElem.length ? `0px 0px -${fixedElem[0].clientHeight}px 0px` : '0px 0px 0px 0px',
            threshold: 1.0
        };

        let callback = (entries, observer) => {
            entries.forEach(entry => {
                if(!entry.isIntersecting){
                    if(entry.target.tagName === 'TEXTAREA'){
                        options.root.scrollTop = options.root.scrollHeight;
                    }else{
                        entry.target.scrollIntoView({'block':'center'});
                    }
                }
            });
        };

        this.defaults.observer = new IntersectionObserver(callback, options);
        this.defaults.observer.observe(target);

        return this.defaults.observer;
    }

    detachEvents() {
        this.$el.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }

    resetPlaceHolder () {
        if(!this.$el.hasClass('ui-placeholder') && !this.$el.hasClass('ui-placeholder-def')) {
            this.$el.find('input, textarea, select').attr('placeholder', this.placeholderOn);
        }
    }
    activeFocus(_this){
        this.changeHandler(_this);
    }
    /**
     * 데이터 값 3자리마다 쉼표 추가
     * @param num    Number 값 
     */
    commaSet(num){
        let len, point, str;
        num = num.replace(/ /g, ''); // 공백제거
        num = num + "";
        point = num.length % 3;
        len = num.length;

        str = num.substring(0, point);
        while (point < len){
            if (str != "") str += ",";
            str += num.substring(point, point+3);
            point += 3;
        }
        return str
    }
    // s: 20231121 조, 경 단위 추가 및 작동방식 변경
    unitSet(num, lastUnit = false) { //숫자 한글단위 추가를 위한 분리
        const _this = this;
        const tempVal = num.toString().replace(/\B(?=(\d{4})+(?!\d))/g, ",");
        const tempArr = tempVal.split(',').reverse();
        
        const unitArr =  lastUnit == true ? ["", "만", "억", "조", "경"] : ["", "", "", "", ""]
        const maxUnitString = unitArr.length;
        let unitText = tempArr.map((v, i) => {
            if (i < maxUnitString && Number(v) > 0) return `${_this.setCommaWithDecimalPoint(v)}${unitArr[i]}`;
        }).reverse().join(' ').trim();
        return (unitText ? unitText : "0") + `${lastUnit == true ? '원' : ''}`;
    }
    setCommaWithDecimalPoint(val){
        try {
            var parts = Number(val).toString().split(".");
            return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",") + (parts[1] || parts.length === 2 ? "." + parts[1] : "");
        } catch (error) {
            return val
        }
    }
    // e: 20231121 조, 경 단위 추가 및 작동방식 변경 

    /*! s: FETASK-a11y page input 셀렉트 Type v.1.0.0 */
    isA11yFormBox(){
        requestAnimationFrame(async () => {
            const isA11yCheck = isA11yCheckVersion(); //html a11y class존재시 실행

            if(isA11yCheck){
                /**검색어 입력 및 dateSpinner */
                const keyWordBox = document.querySelectorAll('.input-txt-group');

                keyWordBox.forEach((item) => {
                    const isSearchIcon = item?.querySelector('.ico-search-input');
                    const inputEle = item?.querySelector('.ui-text-del');

                    if(inputEle){
                        setTimeout(() => {
                            inputEle.removeAttribute('style');
                        },500);
                    }

                    if(!isSearchIcon){
                        item.setAttribute('aria-hidden','false');
                    }
                });

                //selectbox 유형별 접근성 대응
                const isCheckSelect = this.$el.hasClass('selectbox-arrow-group') || this.$el.hasClass('selectbox-group'); //formBox select형식 체크해서 tab커서 가는거 막고 접근성 추가

                if(isCheckSelect){

                    const delay = new Promise((resolve) => setTimeout(resolve, 500));

                    await delay;
                    
                    this.$el.closest('.form-box-group.ui-formBox').attr({'tabindex':'0'});

                    this.$el.closest('.form-box-group.ui-formBox').on('click', (e) => {
                        e.stopPropagation();
                        e.preventDefault();
                        const { currentTarget } = e;
    
                        currentTarget.removeAttribute('tabindex');
                        currentTarget.removeAttribute('role');
                        currentTarget.removeAttribute('title');
                    });

                    this.$el.find('select.custom-ui').attr({'aria-disabled':'true', 'tabindex':'-1','aria-hidden':'true'}).css({'display':'none'});
                    this.$el.find('.ui-select-btn.disabled').attr({'aria-disabled':'true'});

                    const isCheckDisabled = this.$el.closest('.selectbox-group').hasClass('disabled');

                    if(isCheckDisabled){
                        this.$el.find('select.custom-ui').next().attr({'disabled':'true','aria-disabled':'true'});
                    }
                }

                //셀렉트 버튼 접근성 추가 대응(PopupSelect.js - a11yPopupInit)
                if(this.$el.closest('.ui-input').hasClass('done')){
                    this.$el.closest('.ui-input').find('.ui-select-btn').children().removeAttr('aria-hidden');
                    if(this.$el.closest('.ui-input').find('.ui-select-btn').text()?.length){
                        // this.$el.find('.ui-select-btn').attr('aria-selected','true'); // A11YTASK-402 FPMINV0500000100S (비상장주식 시세조회 > 내가 설정한 순) 관련 요청으로 주석처리
                        this.$el.find('.select-txt-wrap').removeAttr('aria-hidden');
                    }
                }else{
                    this.$el.find('.ui-select-btn').children().attr('aria-hidden', 'true');
                    // this.$el.find('.ui-select-btn').attr('aria-selected','false'); // A11YTASK-402 FPMINV0500000100S (비상장주식 시세조회 > 내가 설정한 순) 관련 요청으로 주석처리
                    this.$el.find('.select-txt-wrap').removeAttr('aria-hidden');
                }
            }
        });
    }
    /*! e: FETASK-a11y page input 셀렉트 Type v.1.0.0 */
}

export default Input;
